import React from 'react';

import client1 from './styling/images/clientlist/1.jpg';
import client2 from './styling/images/clientlist/2.png';
import client3 from './styling/images/clientlist/3.png';
import client4 from './styling/images/clientlist/4.png';
import client5 from './styling/images/clientlist/5.png';
import client6 from './styling/images/clientlist/6.png';
import client7 from './styling/images/clientlist/7.png';
import client8 from './styling/images/clientlist/8.jpg';
import client9 from './styling/images/clientlist/9.png';

const ClientList = () => {
  const clientlist = [
    { image: client1},
    {image: client2},
    { image: client3},
    {image: client4},
    { image: client5},
    {image: client6},
    {image: client7},
    {image: client8},
    {image: client9}
    ];
  return (
    <div>
    <style>
        {`
        .clientlist {
        font-family: 'Arial', sans-serif;
    padding: 40px;
    margin-top:0;
    padding-top: 0;
    background-color: #f9f9f9;
}
.heading{
    font-size: 32px;
    word-spacing: 5px;
    font-weight: bold;
    color: black;
    text-align: center;
    margin-top:0;
    margin-bottom: 5%;

    
}
.image-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    gap: 60px;
    align-items:center;
}

.image-card {
    border: 1px solid #ddd;
    border-radius: 8px;
    padding-left: 40px;
    padding-top: 20px;
    padding-bottom:20px;
    margin: 10px;
    background-color: white;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transition: transform 0.2s;
    display: flex;
    align-items: center;
    width: 250px;
    max-width: 100%;
    
}


.image-card:hover {
    transform: scale(1.05);
}

.image {
    width: 220px;
    height: 200px;
    object-fit: contain;
}


/* Responsive Styles */
@media (max-width: 768px) {
    
    .heading{
        font-size: 24px;
    }
    .image-card {
        padding-left: 8px;
        padding-right: 5px;
        padding-top: 15px;
        width: 120px;
    }
    .image-grid{
    align-items: center;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
    gap: 20px;
    }

    .image {
        margin: 0 auto;
        width: 100px;
        height: 80px;
    }
}

@media (max-width: 480px) {
    .image-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));
    gap:20px;
    }

    .image-card {
    width: 60px;
    }

    .image {
            margin: 0 auto;
        width: 60px;
        height: 40px;
    }
}

            `}
            </style>


    <div className='clientlist'>
  <h1 className='heading'>OUR CLIENTS</h1>
  <div className='image-grid'>
  {clientlist.map((image, index) => (
        <div key={index} className="image-card">
          <img src={image.image} alt="" className="image" />
        </div>
      ))}
  </div>
          
  </div>
      </div>
      );
};

export default ClientList;
 